import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

export default {
  preset: definePreset(Lara, {
    semantic: {
      primary: {
        50: '#edf2f8',
        100: '#d6e0ec',
        200: '#adc2da',
        300: '#85a3c7',
        400: '#5c85b5',
        500: '#306294', // brand
        600: '#2b5885',
        700: '#254d75',
        800: '#1f4264',
        900: '#193754',
        950: '#102338',
      },
    },

    components: {
      button: {
        colorScheme: {
          light: {
            root: {
              borderRadius: '10px',
              primary: {
                background: '#306294',
                borderColor: '#306294',
                hoverBorderColor: '#3b6d9f',
                hoverBackground: '#3b6d9f',
                color: 'white',
              },
            },
          },
        },
      },
    },
  }),
  options: {
    darkModeSelector: '.p-dark',
  },
};
